export default __webpack_public_path__ + "9b5913823d3857a05668ebdcfa3ea060.png";